import { useSubscription } from '@/contexts/subscription';
import { Badge } from '@/components/ui/badge';
import { Calendar, AlertTriangle } from 'lucide-react';
import { format, isWithinInterval, addDays, isPast } from 'date-fns';
import { ptBR } from 'date-fns/locale';

export function SubscriptionExpiryBadge() {
  const { subscribed, subscriptionEnd, tier } = useSubscription();

  // Não mostrar para plano Personal ou se não tiver assinatura
  if (!subscribed || tier === 'Personal' || !subscriptionEnd) {
    return null;
  }

  // Validar se subscriptionEnd é uma data válida
  let endDate: Date;
  try {
    endDate = new Date(subscriptionEnd);
    if (isNaN(endDate.getTime())) {
      console.error('[SubscriptionExpiryBadge] Invalid subscription end date:', subscriptionEnd);
      return null;
    }
  } catch (error) {
    console.error('[SubscriptionExpiryBadge] Error parsing subscription end date:', error);
    return null;
  }

  const now = new Date();
  const isExpired = isPast(endDate);
  const isExpiringSoon = isWithinInterval(endDate, { 
    start: now, 
    end: addDays(now, 7) 
  });

  if (isExpired) {
    return (
      <Badge variant="destructive" className="flex items-center gap-1">
        <AlertTriangle className="h-3 w-3" />
        <span className="text-xs">Expirado</span>
      </Badge>
    );
  }

  if (isExpiringSoon) {
    return (
      <Badge variant="warning" className="flex items-center gap-1">
        <Calendar className="h-3 w-3" />
        <span className="text-xs">Expira {format(endDate, 'dd/MM', { locale: ptBR })}</span>
      </Badge>
    );
  }

  return null;
}